export const onSetMode = (mode) => ({
  type: 'SET_MODE',
  mode
})
